import superagent from 'superagent'

export const fetchElevation = (lng, lat) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    // make sure to parse the value and confirm if valid
    const latitud = Number(lat)
    const longitud = Number(lng)
    if (latitud && longitud) {
      superagent
        .get(`${__API_URI__}/Elevation/Get?Latitude=${lat}&Longitude=${lng}`)
        .set('Authorization', `Bearer ${token}`)
        .set('content-type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            reject(err)
          } else {
            resolve(res.body)
          }
        })
    } else {
      reject()
    }
  })
}
